import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "member"
};
var _hoisted_2 = {
  class: "list"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "name"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  key: 1,
  class: "edit-h5"
};
var _hoisted_8 = {
  class: "main"
};
var _hoisted_9 = {
  class: "edit-h5-header"
};
var _hoisted_10 = {
  class: "left"
};
var _hoisted_11 = {
  class: "member"
};
var _hoisted_12 = {
  class: "list list-uniapp"
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = ["src"];
var _hoisted_15 = {
  class: "name"
};
var _hoisted_16 = ["onClick"];
import TUIChatEngine, { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { watchEffect, ref } from '../../../adapter-vue';
import Icon from '../../common/Icon.vue';
import delIcon from '../../../assets/icon/del-icon.svg';
import { isUniFrameWork } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'manage-member',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: () => 0
    },
    isShowDel: {
      type: Boolean,
      default: () => false
    },
    self: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['more', 'del', 'handleMemberProfileShow', 'close'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var totalMember = ref(0);
    var memberList = ref([]);
    var isShowDeleteBtn = ref(false);
    var selfValue = ref({});
    watchEffect(() => {
      totalMember.value = props.total;
      isShowDeleteBtn.value = props.isShowDel;
      memberList.value = props.list;
      selfValue.value = props.self;
    });
    var emits = __emit;
    var handleRoleName = item => {
      var name = '';
      switch (item === null || item === void 0 ? void 0 : item.role) {
        case TUIChatEngine.TYPES.GRP_MBR_ROLE_ADMIN:
          name = TUITranslateService.t('TUIGroup.管理员');
          break;
        case TUIChatEngine.TYPES.GRP_MBR_ROLE_OWNER:
          name = TUITranslateService.t('TUIGroup.群主');
          break;
      }
      if (name) {
        name = "(".concat(name, ")");
      }
      if (item.userID === selfValue.value.userID) {
        name += " (".concat(TUITranslateService.t('TUIGroup.我'), ")");
      }
      return name;
    };
    var getMore = () => {
      emits('more');
    };
    var submit = item => {
      emits('del', [item]);
    };
    var handleMemberProfileShow = user => {
      emits('handleMemberProfileShow', user);
    };
    var close = tabName => {
      emits('close', tabName);
    };
    return (_ctx, _cache) => {
      return !_unref(isUniFrameWork) ? (_openBlock(), _createElementBlock("main", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberList), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "list-item"
        }, [_createElementVNode("aside", {
          class: "aside",
          onClick: $event => handleMemberProfileShow(item)
        }, [_createElementVNode("img", {
          class: "avatar",
          src: item.avatar || 'https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png',
          onerror: "this.onerror=null;this.src='https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png'"
        }, null, 8, _hoisted_4), _createElementVNode("span", _hoisted_5, _toDisplayString(item.nick || item.userID), 1), _createElementVNode("span", null, _toDisplayString(handleRoleName(item)), 1)], 8, _hoisted_3), _createElementVNode("div", {
          onClick: $event => submit(item)
        }, [item.role !== 'Owner' && _unref(isShowDeleteBtn) ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          file: _unref(delIcon),
          width: '16px',
          height: '16px'
        }, null, 8, ["file"])) : _createCommentVNode("", true)], 8, _hoisted_6)]);
      }), 128)), _unref(memberList).length < _unref(totalMember) ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        class: "list-item",
        onClick: getMore
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u67E5\u770B\u66F4\u591A")), 1)) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("main", _hoisted_8, [_createElementVNode("header", _hoisted_9, [_createElementVNode("aside", _hoisted_10, [_createElementVNode("h1", null, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u6210\u5458")), 1)]), _createElementVNode("span", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = $event => close('member'))
      }, _toDisplayString(_unref(TUITranslateService).t("\u5173\u95ED")), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("ul", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberList), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "list-item"
        }, [_createElementVNode("aside", {
          class: "aside",
          onClick: $event => handleMemberProfileShow(item)
        }, [_createElementVNode("img", {
          class: "avatar",
          src: item.avatar || 'https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png',
          onerror: "this.onerror=null;this.src='https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png'"
        }, null, 8, _hoisted_14), _createElementVNode("span", _hoisted_15, _toDisplayString(item.nick || item.userID), 1), _createElementVNode("span", null, _toDisplayString(handleRoleName(item)), 1)], 8, _hoisted_13), _createElementVNode("div", {
          onClick: $event => submit(item)
        }, [item.role !== 'Owner' && _unref(isShowDeleteBtn) ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          file: _unref(delIcon),
          width: '16px',
          height: '16px'
        }, null, 8, ["file"])) : _createCommentVNode("", true)], 8, _hoisted_16)]);
      }), 128)), _unref(memberList).length < _unref(totalMember) ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        class: "list-item",
        onClick: getMore
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u67E5\u770B\u66F4\u591A")), 1)) : _createCommentVNode("", true)])])])]));
    };
  }
});